import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";

import type { NoticeItem } from "src/types/notice/noticeTypes";

type Props = {
  list: NoticeItem[];
  onEdit: (item: NoticeItem) => void;
  onDelete: (item: NoticeItem) => void;
  onTogglePinned: (item: NoticeItem, pinnedYn: boolean) => void;
  onToggleActive: (item: NoticeItem, activeYn: boolean) => void;
};

export default function NoticeListTable({
  list,
  onEdit,
  onDelete,
  onTogglePinned,
  onToggleActive,
}: Props) {
  return (
    <Table size="small" sx={{ minWidth: 980 }}>
      <TableHead>
        <TableRow>
          <TableCell width={90}>ID</TableCell>
          <TableCell width={90}>PIN</TableCell>
          <TableCell width={90}>ACTIVE</TableCell>
          <TableCell width={120}>TARGET</TableCell>
          <TableCell>제목</TableCell>
          <TableCell width={120}>정렬</TableCell>
          <TableCell width={260}>기간</TableCell>
          <TableCell width={220}>관리</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {list.length === 0 ? (
          <TableRow>
            <TableCell colSpan={8} align="center" sx={{ py: 6, color: "text.secondary" }}>
              데이터가 없습니다.
            </TableCell>
          </TableRow>
        ) : (
          list.map((r) => (
            <TableRow key={r.noticeId} hover>
              <TableCell>{r.noticeId}</TableCell>

              <TableCell>
                <Switch
                  checked={!!r.pinnedYn}
                  onChange={(_, v) => onTogglePinned(r, v)}
                  size="small"
                />
              </TableCell>

              <TableCell>
                <Switch
                  checked={!!r.activeYn}
                  onChange={(_, v) => onToggleActive(r, v)}
                  size="small"
                />
              </TableCell>

              <TableCell>{String(r.noticeTarget)}</TableCell>

              <TableCell>
                <div style={{ fontWeight: 700 }}>{r.noticeTtl}</div>
                {r.noticeFileUrl ? (
                  <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                    파일: {r.noticeFileUrl}
                  </div>
                ) : null}
              </TableCell>

              <TableCell>{r.noticeOrder}</TableCell>

              <TableCell>
                <div style={{ fontSize: 12 }}>
                  {fmtDate(r.activeStrDatetime)} ~ {fmtDate(r.activeEndDatetime)}
                </div>
              </TableCell>

              <TableCell>
                <Stack direction="row" spacing={1}>
                  <Button size="small" variant="outlined" onClick={() => onEdit(r)}>
                    수정
                  </Button>
                  <Button size="small" variant="outlined" color="error" onClick={() => onDelete(r)}>
                    삭제
                  </Button>
                </Stack>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}

function fmtDate(iso?: string) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const yy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${yy}-${mm}-${dd} ${hh}:${mi}`;
}
